export const categories = [
  {
    id: 'dianying',
    name: '电影',
    slug: 'dianying',
    icon: 'ri-movie-2-line',
    description: '最新热门电影，涵盖动作、喜剧、科幻、爱情等多种类型，高清画质随心看。',
    articleCount: 126,
  },
  {
    id: 'dianshiju',
    name: '电视剧',
    slug: 'dianshiju',
    icon: 'ri-tv-line',
    description: '热播电视剧全集在线观看，国产剧、韩剧、美剧、日剧一网打尽。',
    articleCount: 98,
  },
  {
    id: 'zongyi',
    name: '综艺',
    slug: 'zongyi',
    icon: 'ri-live-line',
    description: '热门综艺节目最新期数，音乐、选秀、真人秀、脱口秀精彩不停。',
    articleCount: 85,
  },
  {
    id: 'dongman',
    name: '动漫',
    slug: 'dongman',
    icon: 'ri-ghost-line',
    description: '精选动漫新番与经典佳作，日漫、国漫、剧场版应有尽有。',
    articleCount: 112,
  },
  {
    id: 'jilupian',
    name: '纪录片',
    slug: 'jilupian',
    icon: 'ri-film-line',
    description: '高品质纪录片，探索自然、历史、科技、人文的无限魅力。',
    articleCount: 64,
  },
  {
    id: 'duanshipin',
    name: '短视频',
    slug: 'duanshipin',
    icon: 'ri-vidicon-line',
    description: '精彩短视频合集，创意、搞笑、生活、美食，碎片时间轻松看。',
    articleCount: 203,
  },
];

export const categorySlugMap: Record<string, string> = {
  dianying: '电影',
  dianshiju: '电视剧',
  zongyi: '综艺',
  dongman: '动漫',
  jilupian: '纪录片',
  duanshipin: '短视频',
};